const constructors = new Map();
export function register(type, constructor) {
    constructors.set(type, constructor);
}
export function factory(node, copy) {
    const constructor = constructors.get(node.type);
    if (!constructor) {
        throw RangeError(`No node factory constructor for ${JSON.stringify(node)}`);
    }
    return new constructor(Object.assign({}, node, { copy: typeof copy === 'function' ? copy : undefined }));
}
export default factory;
//# sourceMappingURL=factory.js.map